import CourseUnitReportData from './CourseUnitReportData';

export default CourseUnitReportData;
